// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zDSH","left":"styles_left__3lpM8"};